import React from 'react'

import * as MdIcons from 'react-icons/md'
import { useParams, useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { useFindSiteAssignees } from '@hooks/catalogs/assignees'
import { useDate } from '@hooks/dates'
import { useFindTask } from '@hooks/task/find'
import { IGenericAssignment } from '@interfaces/task/generic/IGenericAssignment'

import {
  CardBody,
  CardFooter,
  CardHeader,
  CarHeaderAndBodyContainer,
  InfoContainer,
  Label,
  ResourceCardContainer,
  Subtitle,
  Title,
  Value,
} from './styles'

interface IProps {
  resource: IGenericAssignment
  onPress: () => void
  isReadOnly?: boolean
}
export function ResourcesCard({ resource, onPress, isReadOnly }: IProps) {
  const theme = useTheme()
  const { formatDate } = useDate()
  const { data: rawAssignees } = useFindSiteAssignees()
  const assignees = rawAssignees ?? []
  const { taskId } = useParams<{ taskId: string }>()

  const { data: rawTask } = useFindTask(Number(taskId))
  const task = rawTask ?? ({} as NonNullable<typeof rawTask>)

  const filteredAssignees = assignees.filter((assignee) =>
    assignee.resourceIds.includes(resource.resourceId),
  )

  function getLocalStartTime() {
    const newStartTime = new Date(task.startTime)
    return formatDate(newStartTime).time
  }

  return (
    <ResourceCardContainer>
      <CarHeaderAndBodyContainer>
        <CardHeader>
          <Title>{resource.resourceDescription}</Title>

          {!isReadOnly && (
            <button onClick={onPress} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', margin: '-8px -8px 0 0', minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MdIcons.MdMoreVert
                size={24}
                color={theme.colors.text}
              />
            </button>
          )}
        </CardHeader>

        <CardBody>
          {filteredAssignees.length > 0 ? (
            <>
              <Subtitle>{`${resource.assigneeIds.length} assignees assigned`}</Subtitle>
            </>
          ) : (
            <Subtitle>This resource doesn't have assignees</Subtitle>
          )}
        </CardBody>
      </CarHeaderAndBodyContainer>
      <CardFooter>
        <InfoContainer>
          <MdIcons.MdPerson
            size={24}
            color={theme.colors.text}
          />
          <Label>Crew Size</Label>
          <Value>{resource.crewSize}</Value>
        </InfoContainer>
        <InfoContainer>
          <MdIcons.MdAccessTime
            size={24}
            color={theme.colors.text}
          />
          <Label>Start time</Label>
          <Value>{getLocalStartTime()}</Value>
        </InfoContainer>
        <InfoContainer>
          <MdIcons.MdHourglassBottom
            size={24}
            color={theme.colors.text}
          />
          <Label>Duration</Label>
          <Value>{`${resource.duration} hours`}</Value>
        </InfoContainer>
      </CardFooter>
    </ResourceCardContainer>
  )
}
